// Spec: docs/730-frontend-app-status.md
// Agent: /AGENTS.md#spec-workflow

import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/globals.css';
import { App } from './App';
import { installStatusSessionExpiryInterceptor } from './statusSessionExpiry';

installStatusSessionExpiryInterceptor();

const root = document.getElementById('root');

if (!root) {
  throw new Error('Missing root element');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
